// src/mediator/EventDebugger.js

export class EventDebugger {
    mediator;
    rules;
    
    constructor(mediator) {
        this.mediator = mediator;
        this.rules = [];
    }

    /**
     * Beobachte ein Event-Muster per Wildcard (auch exakt möglich)
     * @param {string} pattern - z.B. 'refactor:*' oder 'marker:hover'
     * @param {string} [label] - Optionaler Label im Log
     */
    watch(pattern, label = '') {
        const regex = new RegExp('^' + pattern.replace(/\*/g, '.*') + '$');
        this.rules.push({ regex, label });

        this.mediator.watchOnly(pattern, (eventName, payload) => {
            const prefix = label ? `[event:${label}]` : `[event:${eventName}]`;
            console.debug(prefix, payload);
        });
    }

    /**
     * Beispiel: Aktivieren von Standard-Debug-Bereichen
     */
    enableDefaultWatchList() {
        //this.watch('refactor:*');
    }
}
